// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-response-item__shareholding-tile-list{pointer-events:none}", ""]);
// Exports
module.exports = exports;
